module.exports = __webpack_public_path__ + "static/media/cloud-sun-rain.6b1de896.svg";